package com.schoolconnect.app.feature.schoolusers

import com.schoolconnect.app.datasource.network.response.LookupItemResponse
import com.schoolconnect.app.repository.systemlookup.SystemLookupOptions
import com.schoolconnect.app.repository.systemlookup.SystemLookupRepository

/** Male/Female only — Other is excluded from School User forms. */
internal fun schoolUserGenderLabelsFrom(items: List<LookupItemResponse>): List<String> =
    items.mapNotNull { item ->
        val code = item.code?.trim()?.uppercase().orEmpty()
        val label = item.displayValue?.trim()?.takeIf(String::isNotBlank)
            ?: item.code?.trim()?.takeIf(String::isNotBlank)
            ?: return@mapNotNull null
        val isMaleOrFemale = code == "M" || code == "F" ||
            label.equals("Male", ignoreCase = true) ||
            label.equals("Female", ignoreCase = true)
        label.takeIf { isMaleOrFemale }
    }

internal suspend fun schoolUserGenderLabels(): List<String> {
    val loaded = SystemLookupRepository.loadCategoryItems("GENDER").getOrDefault(emptyList())
    val items = loaded.ifEmpty { SystemLookupOptions.activeItems("GENDER") }
    return schoolUserGenderLabelsFrom(items)
}

internal fun schoolUserGenderDisplayLabel(raw: String): String {
    val normalized = raw.trim()
    if (normalized.isBlank()) return ""
    if (normalized.equals("Male", ignoreCase = true) ||
        normalized.equals("Female", ignoreCase = true)
    ) {
        return normalized.replaceFirstChar { it.uppercase() }
    }
    return when (normalized.uppercase()) {
        "M" -> "Male"
        "F" -> "Female"
        else -> SystemLookupOptions.label("GENDER", normalized).ifBlank { normalized }
    }
}
